'use strict';

var App = require('app');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var SelectValuesInputView = require('components/common/views/select_values_dialog_view');

var BatchSelectValuesView = Marionette.LayoutView.extend({
    template: require('components/common/templates/batch_select_values_dialog'),

    ui: {
        selectedCategory: '#js-category-select',
        save: '#js-btn-save',
        cancel: '#js-btn-cancel',
    },

    regions: {
        selectValuesInputRegion: '#selectValuesInput',
    },

    events: {
        'change @ui.selectedCategory': 'changeCategory',
        'click @ui.save': 'saveClicked',
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.devices = options.collection.selected;

        this.controller.getUniqueSelectedTypes(this, this.devices, {});
    },

    serializeData: function () {
        var data = {
            categories: _.sortBy(_.values(this.deviceGroups.groups), 'name'),
            selectedCategoryID: this.selectedCategoryID,
        };
        return data;
    },

    insertSelectValuesInputView: function () {
        if (!this.selectedValues) {
            return;
        }

        Misc.setDisabled('#js-category-select', true);

        this.selectValuesInputView = new SelectValuesInputView.Input({
            options: [
                { name: i18n.TR('Register'), values: this.values.Registers.toJSON() },
                { name: i18n.TR('Coils'), values: this.values.Coils.toJSON() },
                { name: i18n.TR('Input Register'), values: this.values.Input ? this.values.Input.toJSON() : [] },
                { name: i18n.TR('Discrete Input'), values: this.values.Discrete ? this.values.Discrete.toJSON() : [] },
            ],
            selectedValues: this.selectedValues,
            multi: true,
            useCustomValues: true,
            showUpdateClassDropdown: true,
            AllowedValueTypes: ['MBR', 'MBC', 'MBI', 'MBD'],
            update_values_cb: function (changes) {
                var deleted = changes.deleted;
                var added = changes.added;
                App.hideModal();

                // TODO: The selected values are updated sequentially. Provide
                //       dedicated REST endpoint for bulk-update.

                var deferreds = [];

                // 1. delete elements
                for (var i = 0; i < deleted.length; ++i) {
                    var model = deleted[i];
                    deferreds.push(model.destroy());
                }

                // 2. add new elements
                for (var i = 0; i < added.length; ++i) {
                    var value = Values.fromSpec(params.deviceID, added[i]);
                    deferreds.push(value.save());
                }

                // 3. Synchronize and update UI
                $.when
                    .apply($, deferreds)
                    .done(function () {
                        params.update_cb();
                    })
                    .fail(function () {
                        params.update_cb();
                        Notification.show(
                            'error',
                            i18n.TR('Fehler'),
                            i18n.TR('Wertauswahl konnte nicht aktualisiert werden.')
                        );
                    });
            },
        });
        this.showChildView('selectValuesInputRegion', this.selectValuesInputView);
    },

    changeCategory: function () {
        this.selectedCategoryID = this.ui.selectedCategory.val();

        this.controller.requestValues(this, {});
    },

    saveClicked: function (e) {
        e.preventDefault();

        var changes = this.selectValuesInputView.getChanges();

        App.hideModal();

        var data = {
            added: [],
            changed: [],
            deleted: [],
            devices: this.deviceGroups.groups[this.selectedCategoryID].devices,
        };

        for (var i = 0; i < changes.deleted.length; ++i) {
            data.deleted.push(changes.deleted[i].toJSON());
        }
        for (var i = 0; i < changes.added.length; ++i) {
            data.added.push(changes.added[i].toJSON());
        }
        for (var i = 0; i < changes.changed.length; ++i) {
            data.changed.push(changes.changed[i].toJSON());
        }

        App.ajax({
            method: 'POST',
            url: '/api/v1/devices/values/config-multi/edit',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(data),

            success: function (data) {
                Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Wertauswahl erfolgreich übertragen.'));
            },
            error: function (data) {
                Notification.show('error', i18n.TR('Fehler'), i18n.TR('Wertauswahl konnte nicht angewandt werden.'));
            },
        });
    },

    onRender: function () {
        this.insertSelectValuesInputView();
        Misc.initSelectPicker();

        if (this.selectedCategoryID) {
            var num = this.deviceGroups.groups[this.selectedCategoryID].deviceCount;
            var category = this.deviceGroups.groups[this.selectedCategoryID].category;
            var type = this.deviceGroups.groups[this.selectedCategoryID].type;

            var text = ' - ';
            text += i18n.TR(Handlebars.helpers.TYPE_DEVICE(category, type).string);
            text += ' (' + num + ' ' + (num == 1 ? i18n.TR('Gerät') : i18n.TR('Geräte')) + ')';

            $('#js-modal-title').append(document.createTextNode(text));
        }
    },

    onShow: function () {
        Misc.initSelectPicker();
    },
});

module.exports = BatchSelectValuesView;
